// @flow
import type { ComponentType } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import i18n from 'i18n-js';

import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { MdMap } from 'react-icons/lib/md';

import Logo from './logo.png';
import * as selectors from '../../../reducers';
import ActiveIcon from '../../ActiveIcon';
import styles from './navbarMainTabs.css';


type NavbarTabPropTypes = {
  to: string,
  title?: string,
  Icon?: ComponentType<*>,
  imageURL?: string,
  showAlerted?: boolean,
};

type NavbarMainTabsPropTypes = {
  hasTrips: boolean,
};

const NavbarTab = ({
  title,
  to,
  Icon,
  showAlerted,
  imageURL,
}: NavbarTabPropTypes) => (
  <NavLink
    key={to}
    className={styles.navbarTab}
    activeClassName={styles.active}
    to={to}
  >
    {
      showAlerted ? (<ActiveIcon />) : null
    }
    {
      imageURL ? (
        <img src={imageURL} alt="On the bus" />
      ) : (
        <Fragment>
          { Icon && <Icon size={20} /> }
          <span className={styles.text}>
            { title }
          </span>
        </Fragment>
      )
    }
  </NavLink>
);

const NavbarMainTabs = ({ hasTrips }: NavbarMainTabsPropTypes) => (
  <div className={styles.navbarMainTabs}>
    <NavbarTab
      imageURL={Logo}
      to="/admin/backend"
    />
    <NavbarTab
      showAlerted={hasTrips}
      title={i18n.t('common.liveMap')}
      Icon={MdMap}
      to="/admin/map"
    />
  </div>
);
const NavbarMainTabsConnect = withRouter(connect(
  (state) => {
    const trips = selectors.getTrips(state);
    return {
      hasTrips: trips.length > 0,
    };
  },
)(NavbarMainTabs));

export default NavbarMainTabsConnect;



// WEBPACK FOOTER //
// ./src/scripts/components/Navbar/NavbarMainTabs/index.jsx